import {EUserRole} from '@/app/shared/state/user-role';
import {RouteRecordRaw} from 'vue-router';

export const AdminHome: RouteRecordRaw = {
    path: '/admin',
    name: 'adminHome',
    component: () => import('./index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin, EUserRole.helpdesk] },
    },
};

export const AdminServiceDetail: RouteRecordRaw = {
    path: '/admin/service/:name',
    name: 'adminServiceDetail',
    component: () => import('./dashboard/service-detail/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin, EUserRole.helpdesk] },
    },
};

export const AdminEvents: RouteRecordRaw = {
    path: '/admin/events',
    name: 'adminEvents',
    component: () => import('./events/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    },
};

export const AdminSaga: RouteRecordRaw = {
    path: '/admin/saga?sagaId',
    name: 'adminSaga',
    component: () => import('./saga/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    },
};

export const AdminHangingImklValidations: RouteRecordRaw = {
    path: '/admin/hangingimklvalidations',
    name: 'adminHangingImklValidations',
    component: () => import('./dashboard/hanging-imkl-validations/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
};

export const AdminFailedPmklPackages: RouteRecordRaw = {
    path: '/admin/failedpmklpackages',
    name: 'adminFailedPmklPackages',
    component: () => import('./dashboard/failed-pmkl-packages/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
};

export const AdminHangingPendingRequests: RouteRecordRaw = {
    path: '/admin/hangingpendingrequests',
    name: 'adminHangingPendingRequests',
    component: () => import('./dashboard/hanging-pending-requests/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
};

export const AdminHangingPendingPmkl2Assets: RouteRecordRaw = {
    path: '/admin/hangingpmkl2assets',
    name: 'adminHangingPmkl2Assets',
    component: () => import('./dashboard/hanging-pending-pmkl-2-assets/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
};

export const AdminFailedMissingKlim: RouteRecordRaw = {
    path: '/admin/failedmissingklim',
    name: 'adminFailedMissingKlim',
    component: () => import('./dashboard/failed-missing-klim/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
};

export const AdminHangingMapRequests: RouteRecordRaw = {
    path: '/admin/hangingmaprequests',
    name: 'adminHangingMapRequests',
    component: () => import('./dashboard/hanging-map-requests/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
}

export const AdminOverdueMapRequests: RouteRecordRaw = {
    path: '/admin/overduemaprequests',
    name: 'adminOverdueMapRequests',
    component: () => import('./dashboard/overdue-maprequests/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
}

export const AdminMapRequestRespondersIncorrectState: RouteRecordRaw = {
    path: '/admin/maprequestrespondersincorrectstate',
    name: 'adminMapRequestRespondersIncorrectState',
    component: () => import('./dashboard/maprequest-responders-incorrect-state/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
}

export const AdminMapRequestWithFinancialAnomalies: RouteRecordRaw = {
    path: '/admin/maprequestwithfinancialanomalies',
    name: 'adminMapRequestWithFinancialAnomalies',
    component: () => import('./dashboard/maprequest-with-financial-anomalies/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
}

export const AdminUnprocessedShoppingCarts: RouteRecordRaw = {
    path: '/admin/unprocessedshoppingcarts',
    name: 'adminUnprocessedShoppingCarts',
    component: () => import('./dashboard/unprocessed-shopping-carts/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    }
};

export const AdminMapRequestOverview: RouteRecordRaw = {
    path: '/admin/maprequest',
    name: 'adminMapRequest',
    component: () => import('./maprequest/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminMapRequestDetail: RouteRecordRaw = {
    path: '/admin/maprequest/:id',
    name: 'adminMapRequestDetail',
    component: () => import('./maprequest/map-request.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminArchivedMapRequestDetail: RouteRecordRaw = {
    path: '/admin/maprequest/:id/archived',
    name: 'adminArchivedMriDetail',
    component: () => import('./maprequest/archived-map-request.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] }
    }
}

export const AdminMapRequestDetailAsMri: RouteRecordRaw = {
    path: '/admin/maprequest/:id/mri',
    name: 'adminMapRequestDetailAsMri',
    component: () => import('../mri/map-request.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminMapRequestDetailAsUna: RouteRecordRaw = {
    path: '/admin/maprequest/:id/una/:zoneId/:archived',
    name: 'adminMapRequestDetailAsUna',
    component: () => import('../una/map-request.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminUser: RouteRecordRaw = {
    path: '/admin/user',
    name: 'adminUser',
    component: () => import('./user/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminUserDetail: RouteRecordRaw = {
    path: '/admin/user/:userId/:organisationId?',
    name: 'adminUserDetail',
    component: () => import('./user/user.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminOrganisation: RouteRecordRaw = {
    path: '/admin/organisation',
    name: 'adminOrganisation',
    component: () => import('./organisation/pages/overview/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminOrganisationDetail: RouteRecordRaw = {
    path: '/admin/organisation/:organisationId',
    name: 'adminOrganisationDetail',
    component: () => import('./organisation/pages/detail/organisation-detail.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminOrganisationDetailPdaZone: RouteRecordRaw = {
    path: '/admin/organisation/:organisationId/pdazone/:zoneId',
    props: true,
    name: 'adminOrganisationPdaZone',
    component: () => import('./organisation/pages/pda-zone-detail/pda-zone-detail.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminPdaZoneMapRequestDetail: RouteRecordRaw = {
    path: '/admin/organisation/:organisationId/pdazone/:zoneId/maprequest/:id',
    props: true,
    name: 'adminPdaZoneMapRequest',
    component: () => import('../pda/map-request.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminSubOrganisationDetailUnaZone: RouteRecordRaw = {
    path: '/admin/organisation/suborganisation/:organisationId/unazone/:zoneId',
    props: true,
    name: 'adminSubOrganisationDetailUnaZone',
    component: () => import('./organisation/pages/sub-organisation-una-zone/sub-organisation-una-zone.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminSubOrganisationDetail: RouteRecordRaw = {
    path: '/admin/organisation/suborganisation/:organisationId',
    name: 'adminSubOrganisationDetail',
    component: () => import('./organisation/pages/sub-organisation/sub-organisation.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminSubOrganisationDetailUnaKlimZone: RouteRecordRaw = {
    path: '/admin/organisation/suborganisation/:organisationId/unazoneklim/:zoneId',
    props: true,
    name: 'adminSubOrganisationDetailUnaKlimZone',
    component: () => import('./organisation/pages/sub-organisation-una-zone/sub-organisation-una-zone.vue'),
    meta: {
        authorize: { roles: [EUserRole.helpdesk, EUserRole.admin] },
    },
};

export const AdminInvoice: RouteRecordRaw = {
    path: '/admin/invoice',
    name: 'adminInvoice',
    component: () => import('./invoice/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    },
};


export const AdminSettings: RouteRecordRaw = {
    path: '/admin/settings',
    name: 'adminSettings',
    component: () => import('./settings/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.admin] },
    },
};

export default [
    AdminHome,
    AdminServiceDetail,
    AdminEvents,
    AdminSaga,
    AdminHangingImklValidations,
    AdminHangingMapRequests,
    AdminOverdueMapRequests,
    AdminMapRequestWithFinancialAnomalies,
    AdminFailedPmklPackages,
    AdminFailedMissingKlim,
    AdminHangingPendingRequests,
    AdminHangingPendingPmkl2Assets,
    AdminMapRequestRespondersIncorrectState,
    AdminUnprocessedShoppingCarts,
    AdminMapRequestOverview,
    AdminMapRequestDetail,
    AdminArchivedMapRequestDetail,
    AdminMapRequestDetailAsMri,
    AdminMapRequestDetailAsUna,
    AdminUser,
    AdminUserDetail,
    AdminOrganisation,
    AdminOrganisationDetail,
    AdminOrganisationDetailPdaZone,
    AdminSubOrganisationDetail,
    AdminSubOrganisationDetailUnaZone,
    AdminSubOrganisationDetailUnaKlimZone,
    AdminInvoice,
    AdminSettings,
    AdminPdaZoneMapRequestDetail];
